import { useLocation } from 'react-router-dom'
import { Box, styled, Typography } from '@mui/material'
import BackTopSvg from 'assets/images/svg/common/back-top.svg'
import { useEffect, useState } from 'react'
const BackBox = styled(Box)`
  padding: 0 !important;
  width: 120px !important;
  height: 120px;
  position: absolute;
  right: 100px;
  top: -55px;
  cursor: pointer;
  z-index: 19;
  text-align: center;
  display: block !important;
  background-color: ${props => props.theme.colors.background.dialog};
  img {
    margin: 26px auto 12px auto;
    display: block;
  }
  @media (max-width: 1200px) {
    top: -190px;
  }
`
export default function BlackBackTop() {
  const location = useLocation()
  const [isShow, setIsShow] = useState(true)
  useEffect(() => {
    if (location.pathname.includes('/mint/') || location.pathname.includes('/login')) {
      setIsShow(false)
    }
  }, [location])
  const onScroll = () => {
    let timer = 1000
    cancelAnimationFrame(timer)
    timer = requestAnimationFrame(function fn() {
      const oTop = document.body.scrollTop || document.documentElement.scrollTop
      if (oTop > 0) {
        document.body.scrollTop = document.documentElement.scrollTop = oTop - 50
        timer = requestAnimationFrame(fn)
      } else {
        cancelAnimationFrame(timer)
      }
    })
  }

  return isShow ? (
    <BackBox onClick={() => onScroll()}>
      <img alt="" src={BackTopSvg} onClick={onScroll} />
      <Typography variant="h6" component="div" color="#565656">
        Back to Top
      </Typography>
    </BackBox>
  ) : (
    <></>
  )
}
